/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_SubInputs */

const en_cp_lead_sub = /** @type {(inputs: Cp_Lead_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The pattern used by Claude Campus, the OpenAI Student Collective, GDG on Campus and Cursor Campus Leads — no cash stipend, but a free seat, club credits and tiers you can put on a CV.`)
};

const id_cp_lead_sub = /** @type {(inputs: Cp_Lead_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pola yang dipakai Claude Campus, OpenAI Student Collective, GDG on Campus, dan Cursor Campus Leads — tanpa uang tunai, dengan kursi gratis, kredit klub, dan tier yang bisa dibawa ke CV.`)
};

/**
* | output |
* | --- |
* | "The pattern used by Claude Campus, the OpenAI Student Collective, GDG on Campus and Cursor Campus Leads — no cash stipend, but a free seat, club credits and ..." |
*
* @param {Cp_Lead_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_sub = /** @type {((inputs?: Cp_Lead_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_sub(inputs)
	return en_cp_lead_sub(inputs)
});